import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'

// TODO: implement
export const submitResponse = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.submitResponse.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: meFeature.contexts.selectors.zoneContext.asObservable,
        ignoreCheckInPrompt: feature.selectors.ignoreCheckInPrompt.asObservable,
        mood: feature.selectors.checkInCurrentMood.asObservable,
        prompt: feature.selectors.prompt.asObservable,
        response: feature.selectors.response.asObservable,
      })),
      rxjs.mergeMap(
        ({ action, context, ignoreCheckInPrompt, mood, prompt, response }) =>
          context && response
            ? gql.mutations.submitCheckInResponse
                .executor({
                  ...context,
                  mood,
                  prompt: ignoreCheckInPrompt ? undefined : prompt,
                  response,
                })
                .pipe(
                  rxjs.map(result =>
                    feature.actions.submitResponse.success.from(action).create({
                      request: action.data,
                      response: result,
                    }),
                  ),
                  rxjs.catchError(error =>
                    rxjs.of(
                      feature.actions.submitResponse.error.from(action).create({
                        error,
                        request: action.data,
                      }),
                    ),
                  ),
                )
            : rxjs.of(
                feature.actions.submitResponse.cancellation
                  .from(action)
                  .create({
                    reason: !context
                      ? 'Not in a valid zone context'
                      : 'Prompt or response is missing',
                    request: action.data,
                  }),
              ),
      ),
    ),
)
